export const en = {
    'on-handle-copy-link': 'Link to the stream is copied'
}
